import React from 'react';

import { Box, Typography } from '@mui/material';

import { Field, Form } from '@hrlogics/react-components/form';

import { Button } from 'src/components/common';
import { RadioGroupField } from 'src/components/finalForm';
import { SIGN_UP_METHOD_OPTIONS } from 'src/constants/employer';
import { validateWithYupSchema } from 'src/utils/yup';

import { boxStyles, radioFieldStyles, settingsStyles, titleDataSchemaStyles } from './styles';
import { SettingsFormFields, SettingsFormValues } from './types';
import { employeeSettingsFormValidationSchema } from './utils';

interface EmployeeSettingsFormProps {
  onSubmit: (data: SettingsFormValues) => Promise<void>;
  initialValues: SettingsFormValues;
}

export const EmployeeSettingsForm: React.FC<EmployeeSettingsFormProps> = ({
  onSubmit,
  initialValues,
}) => {
  return (
    <Box>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        containerProps={{ sx: boxStyles, rowGap: 3 }}
        validate={validateWithYupSchema(employeeSettingsFormValidationSchema)}
      >
        {({ form, dirty, submitting }) => (
          <React.Fragment>
            <Box sx={settingsStyles}>
              <Typography variant="subtitle1">Employee Sign Up PIN</Typography>
              <Typography variant="body1" color="text.secondary" mt={1}>
                Employees will use this 8 digit PIN as the first part of the sign-up process to
                confirm identity. This is an optional additional layer of security.
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                Format:
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={titleDataSchemaStyles}>
                XXXX-YYYY where XXXX - 4 last digits of SSN, YYYY - year of birth
              </Typography>

              <Field
                name={SettingsFormFields.signUpMethod}
                component={RadioGroupField}
                options={SIGN_UP_METHOD_OPTIONS}
                disabled={submitting}
                sx={radioFieldStyles}
              />
            </Box>

            <Box display="flex" justifyContent="center" alignItems="center" gap={2} mt={2}>
              <Button
                color="error"
                disabled={!dirty && submitting}
                size="medium"
                type="reset"
                variant="outlined"
                onClick={() => form.restart()}
              >
                Reset
              </Button>
              <Button disabled={!dirty} loading={submitting} variant="contained" type="submit">
                Save changes
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Form>
    </Box>
  );
};
